
function EnableDisableButtons(fillOutSubmission){
	
	var me = this;
	var $ = fillOutSubmission.$;
	me.fillOutSubmission = fillOutSubmission;

	me.disableNext = function(){
		$('.nextPage').addClass('disabled').attr('disabled', 'disabled');
	};

	me.enableNext = function(){
		$('.nextPage').removeClass('disabled').removeAttr('disabled');
	};

	me.disableSubmit = function(){
		$('button.submit').addClass('disabled').attr('disabled', 'disabled');
	};

	me.enableSubmit = function(){
		$('button.submit').removeClass('disabled').removeAttr('disabled');
	};

	me.enableDisable = function(){
		// debugger
		var currentPageId = me.fillOutSubmission.getCurrentPageId();

		// console.log( currentPageId ); 

		var isPrivacyChecked = !!$('#confirmPrivacy:checked').length;
		var isCompanyChecked = me.fillOutSubmission.isCompanyChecked();
		var isFraudTypeChecked = !!$("[name=fraud_type_id]:checked").length;
		var isFraudDescribed = !$("[name=fraud_description]").length || !!$("[name=fraud_description]").val().length;
		var isOtherPeopleWithKnowledgeChecked = !!$("[name=other_people_with_knowledge]:checked").length;
		// var numOfEmpty 

		// run code on custom settings
		if(me.runCode(currentPageId)){
			return;
		}

		if( currentPageId === 'enterInternalSubmission' ){

			me.enableNext();

		} else if( currentPageId === 'enterConfirmPrivacy' ){
			var hasUnsolvedRecaptcha = me.fillOutSubmission.recaptcha && ! me.fillOutSubmission.recaptcha.isSolved();
			if( ! isPrivacyChecked || hasUnsolvedRecaptcha ){
				me.disableNext();
			} else {
				me.enableNext();
			}

		} else if( currentPageId === 'enterCompany' ){
			
			if( ! isCompanyChecked ){
				me.disableNext();
			} else {
				me.enableNext();
			}

		} else if( currentPageId === 'enterFraudType' ){

			if( ! isFraudTypeChecked ){
				me.disableNext();
			} else {
				me.enableNext();
			}

		} else if( currentPageId === 'enterFraudDescription' ){

			if( ! isFraudDescribed ){
				me.disableNext();
			} else {
				me.enableNext();
			}

		} else if( currentPageId === 'enterFiles' ){

			me.enableNext();

		} else if( currentPageId === 'enterOtherPeopleWithKnowledge' ){

			if( ! isOtherPeopleWithKnowledgeChecked ){
				me.disableNext();
			} else {
				me.enableNext();
			}

		} else if( currentPageId === 'enterAnonymousDecision' ){

			me.enterAnonymousDecision()

		} else if( currentPageId === 'enterPersonalData'){
			if( me.fillOutSubmission.emptyPersonalDataInputs().length > 0 ){
				me.disableSubmit();
			} else {
				me.enableSubmit();
			}
		}
	}

	me.runCode = function(currentPageId){
		// debugger
		var pages = window.whistle.pages || {};
		var hasCustomCode = typeof pages[currentPageId] == 'object' && 
			typeof pages[currentPageId].buttons == 'function';
		if(hasCustomCode){
			var buttonChanges = pages[currentPageId].buttons();
			if(typeof buttonChanges.next == "boolean"){
				buttonChanges.next ? me.enableNext() : me.disableNext();
			}
			return true;
		}
		return false;
	}

	me.enterAnonymousDecision = function(){

		var wantsToBeAnonymous = me.fillOutSubmission.wantsToBeAnonymous();
		var wantsToBeAnonymousChecked = wantsToBeAnonymous === '1';
		var wantsToBeAnonymousUndefined = typeof wantsToBeAnonymous == 'undefined';
		var whistleblowerCanBeRevealed = me.fillOutSubmission.whistleblowerCanBeRevealed();
		var hasInputsWhistleblowerCanBeRevealed = me.fillOutSubmission.hasInputsWhistleblowerCanBeRevealed();
		var bothOptionsSet = typeof wantsToBeAnonymous !== 'undefined' &&
				typeof whistleblowerCanBeRevealed !== 'undefined' ;
		// debugger
		if( me.fillOutSubmission.isQuestionMode() || ! hasInputsWhistleblowerCanBeRevealed ){
			if( wantsToBeAnonymousUndefined ){
				me.disableSubmit();
				me.disableNext();
			} else {
				me.enableNext();
				me.enableSubmit();
			}

		} else { // fraud report
			if( wantsToBeAnonymousChecked ){
				me.enableSubmit();
				me.disableNext();
			} else if( bothOptionsSet ){
				me.disableSubmit();
				me.enableNext();
			} else {
				me.disableSubmit();
				me.disableNext();
			}				
		}
	}

	me.handle = function(){
		me.enableDisable();
	}

	me.handle();
}